<template>
  <div class="quote-box-component">
    <span v-if="topQuote" class="quotes">&#8220;</span>
    <p class="quote-description" v-html="content"></p>
    <span v-if="bottomQuote" class="quotes">&#8221;</span>
    <p v-if="sign" class="sign">{{ sign }}</p>
  </div>
</template>

<script>
export default {
  name: 'quote-box',
  props: {
    topQuote: {
      type: Boolean,
      default: true,
    },
    bottomQuote: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      required: true,
    },
    sign: {
      type: String,
      default: null,
    },
  },
};
</script>
